module.exports = __webpack_public_path__ + "static/media/wholesale-children-clothing-sets-fall-girl-long.jpg_350x350.6167bdbe.jpg";